import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full py-20 px-6 bg-cream" data-id="element-208">
      <div className="max-w-reading mx-auto" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-210">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-8 leading-tight" data-id="element-211">
            This isn’t about being “organized.”
            <span className="block text-teal mt-2 text-2xl md:text-3xl font-serif italic font-normal" data-id="element-212">
              It’s about being functional under stress.
            </span>
          </h2>

          <div className="space-y-6 text-lg text-body leading-relaxed" data-id="element-213">
            <p data-id="element-214">
              If your child is sick—especially under 5—your life doesn’t operate
              on “normal productivity rules.”
            </p>
            <p data-id="element-215">
              You don’t get quiet mornings. You don’t get predictable weeks.
            </p>
            <p data-id="element-216">
              You get surprise fevers, daycare calls, urgent appointments,
              medication changes, specialists who talk fast, and instructions
              you’re supposed to remember while you’re terrified.
            </p>
            <p className="font-medium text-navy" data-id="element-217">
              And then you’re expected to tell the story perfectly.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-16 p-8 bg-white rounded-xl shadow-sm border border-soft-sage/30" data-id="element-218">
          <h3 className="text-2xl font-bold text-navy mb-4" data-id="element-219">
            The dirty secret: the room rewards clarity.
          </h3>
          <p className="text-lg text-body mb-6" data-id="element-220">
            Not love. Not effort. Not exhaustion.{' '}
            <span className="font-bold text-navy" data-id="element-221">Clarity.</span>
          </p>

          <div className="space-y-4" data-id="element-222">
            <div className="flex items-start gap-4" data-id="element-223">
              <div className="w-1.5 h-1.5 rounded-full bg-red-400 mt-2.5 flex-shrink-0" data-id="element-224" />
              <p className="text-body" data-id="element-225">
                When your story is scattered, you get rushed.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-226">
              <div className="w-1.5 h-1.5 rounded-full bg-red-400 mt-2.5 flex-shrink-0" data-id="element-227" />
              <p className="text-body" data-id="element-228">
                When your meds are “somewhere on your phone,” you get guesswork.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-229">
              <div className="w-1.5 h-1.5 rounded-full bg-red-400 mt-2.5 flex-shrink-0" data-id="element-230" />
              <p className="text-body" data-id="element-231">
                When you can’t remember dates, you get that look.
              </p>
            </div>
          </div>

          <p className="mt-8 text-lg font-medium text-navy italic" data-id="element-232">
            And you walk out with a plan that doesn’t feel like a plan.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-16 text-center" data-id="element-233">
          <h3 className="text-xl md:text-2xl font-serif text-navy mb-4" data-id="element-234">
            The ER‑Ready Mom Binder fixes the part nobody talks about:
          </h3>
          <p className="text-lg md:text-xl text-body max-w-lg mx-auto" data-id="element-235">
            Your brain under pressure. Because your brain is not failing. It’s
            doing what stressed brains do: dropping non-essential memory to keep
            you moving.
          </p>
          <p className="mt-6 font-bold text-teal text-xl" data-id="element-236">
            So we don’t ask you to “try harder.” We give you a system.
          </p>
        </motion.div>
      </div>
    </section>;
}